import { pipe, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { User } from '@app/models/users/users.model';
import { Fetch } from '@app/models/fetch';
import { AuthState, UpdateUser } from '@app/auth/auth.state';
import { Store } from '@ngxs/store';
import { BatteryOrder } from '@app/models/battery/battery-order.model';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../auth/auth.state";
import * as i3 from "@ngxs/store";
export class UserService {
    constructor(fetch, authState, store) {
        this.fetch = fetch;
        this.authState = authState;
        this.store = store;
    }
    update(id, body) {
        return this.fetch.patch('//users', id, body).pipe(switchMap(() => this.authState.getUser()), switchMap((currUser) => {
            if (id === currUser.id) {
                return this.get().pipe(switchMap((newUser) => this.store.dispatch(new UpdateUser(newUser))));
            }
            return of(currUser);
        }));
    }
    changePassword(id, body) {
        return this.fetch.patch(`//users/${id}/password`, '', body);
    }
    changeEmail(id, body) {
        return this.fetch.patch(`//users/${id}/email`, '', body).pipe(switchMap(() => this.authState.getUser()), switchMap((currUser) => {
            if (id === currUser.id) {
                return this.get().pipe(switchMap((newUser) => this.store.dispatch(new UpdateUser(newUser))));
            }
            return of(currUser);
        }));
    }
    get() {
        return this.fetch.getOne('//users', this.authState.userID()).model(User);
    }
    joinDevices(devices) {
        return this.get().pipe(map((user) => {
            for (let i = 0; i < devices.length; i++) {
                if (devices[i].user_id === user.id) {
                    devices[i].user = user;
                }
            }
            return devices;
        }));
    }
    joinDevicesPipe() {
        return pipe(switchMap((devices) => {
            if (devices.length === 0) {
                return of(devices);
            }
            return this.joinDevices(devices);
        }));
    }
    joinNotifications(notifs) {
        return this.get().pipe(map((user) => {
            for (let i = 0; i < notifs.length; i++) {
                if (notifs[i].user_id === user.id) {
                    notifs[i].user = user;
                }
            }
            return notifs;
        }));
    }
    joinNotificationsPipe() {
        return pipe(switchMap((notifications) => {
            if (notifications.length === 0) {
                return of(notifications);
            }
            return this.joinNotifications(notifications);
        }));
    }
    joinLocation(location) {
        return this.get().pipe(map((user) => {
            location.user = user;
            return location;
        }));
    }
    joinLocations(locs) {
        return this.get().pipe(map((user) => {
            for (let i = 0; i < locs.length; i++) {
                if (locs[i].user_id === user.id) {
                    locs[i].user = user;
                }
            }
            return locs;
        }));
    }
    joinLocationPipe() {
        return pipe(switchMap((loc) => this.joinLocation(loc)));
    }
    joinLocationsPipe() {
        return pipe(switchMap((locations) => this.joinLocations(locations)));
    }
    getUserEntitlement() {
        return this.get().pipe(map((user) => user.plan.entitlement.toLowerCase()));
    }
    getUserEntitlementObject() {
        return this.get().pipe(map((user) => user.plan));
    }
    // route for obtaining the purchase link for new batteries
    getPurchaseOptions(deviceID) {
        return this.fetch
            .get(`//users/${this.authState.userID()}/devices/${deviceID}/purchase-options`)
            .model(BatteryOrder);
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.AuthState), i0.ɵɵinject(i3.Store)); }, token: UserService, providedIn: "root" });
